import { Popover, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { useMemo } from 'react';

import { useFilterState } from '../../hooks/useFilterState';
import { DataTableFilterOption, DataTableFilterType } from '../../utils/typings';
import { FilterPopoverButton, FilterPopoverContent } from '../FilterPopoverButton';

type Props<T extends DataTableFilterType> = {
  value: string;
  options: DataTableFilterOption<T>[];
  onChange: (value: string) => void;
};

export const RadioFilterPopover = <T extends DataTableFilterType>({ value, options, onChange }: Props<T>) => {
  const state = useFilterState({
    defaultValue: value,
    onSubmit: onChange,
  });

  const handleChange = (value: string) => {
    onChange(value);
    state.onChange(value);
  };

  const actualLabel = useMemo(() => {
    const option = options.find((n) => String(n.value) == String(state.value));
    return option?.label ?? '';
  }, [options, state.value]);

  return (
    <Popover placement="bottom-start">
      <FilterPopoverButton label={actualLabel} />
      <FilterPopoverContent onClickApply={state.onSubmit} onClickCancel={state.onReset}>
        <RadioGroup value={state.value}>
          <Stack>
            {options?.map((option) => (
              <Radio
                key={option?.label}
                isChecked={option?.value === state.value}
                onChange={() => handleChange(option?.value as string)}
              >
                {option?.label}
              </Radio>
            ))}
          </Stack>
        </RadioGroup>
      </FilterPopoverContent>
    </Popover>
  );
};
